<template>
  <textarea type="text" class="formInput" v-model="model" @keyup="calcHeight()" :style="setBorder()"
            style="padding: 5px 10px !important; line-height: 35px;"
            @keyup.delete="calcHeight()" :ref="`textarea`"
            @keyup="calcHeight()"
            @input="calcHeight()"
            :placeholder="placeholder" :disabled="disableChanges"></textarea>
</template>

<script>
export default {
  name: 'FlexTextarea',
  props: ['model', 'placeholder', 'disableBorder', 'disableChanges'],
  data () {
    return {
    }
  },
  methods: {
    setBorder(){
      if(!this.disableBorder){
        return { border: '1px solid #336699', 'box-shadow': '0 0 1px 0 #6d99c5!important', paddingRight: '0px'}
      }else{
        return { border: 'none', paddingRight: '0px', cursor: 'default', width: '590px;'}
      }
    },
    calcHeight: function () {
      this.$refs.textarea.style.cssText = `height:34px;`
      this.$refs.textarea.style.cssText = `height: ${(this.$refs.textarea.scrollHeight) + 2}px !important;`
      this.$emit('input', this.model)
    }
  },
  mounted () {
    setTimeout(() => {
      this.calcHeight();
    }, 100);
    if(this.disableBorder){
       this.$refs.textarea.style.paddingRight = `0px`
       this.$refs.textarea.style.border = `none`
       this.$refs.textarea.style.cursor = `default`
       this.$refs.textarea.style.width = `590px`
      }
  }
}
</script>

<style scoped lang="less">
  @import '../../assets/css/config.less';
  textarea {
    font-family: 'Assistant', sans-serif;
    resize: none;
    overflow: hidden;
    height: 34px;
    padding: 5px 10px !important;
    min-height: 34px;
  }
</style>



// WEBPACK FOOTER //
// src/components/ui/uiFlexTextarea.vue